


import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { IgrAssessmentApplicationModalComponent } from '../igr-assessment-application-modal/igr-assessment-application-modal.component';

@Component({
  selector: 'app-igr-assessment-asin-verification-modal',
  standalone: false,
  templateUrl: './igr-assessment-asin-verification-modal.component.html',
  styleUrl: './igr-assessment-asin-verification-modal.component.scss'
})
export class IgrAssessmentAsinVerificationModalComponent {
  form!: FormGroup;
  isLoadingPrivileges: boolean = true;
  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;
  privileges: any[] = [];
  isLoading: boolean = false;

  years: number[] = []; // Array to hold year options

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<IgrAssessmentAsinVerificationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public editModeData: any,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.initForm();

    this.getAllPrivileges();

    this.generateYears()
  }

  private generateYears(): void {
    const currentYear = new Date().getFullYear();
    const startYear = 1900;
    this.years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => currentYear - i); 
  }

  initForm(): void {
    const asin = this.editModeData?.asin;
    this.form = this.fb.group({
      asin: [asin || '', [Validators.required, Validators.maxLength(20)]],
      assessmentYear: [null, [Validators.required]],
    });
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload()
    });
  }


  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {

    });
  }





  getAllPrivileges() {
    this.isLoading = true;
    this.apiService
      .get('/privileges/all')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.privileges = response.data.map((priv) => ({
          ...priv,
          formattedPermission: this.toTitleCase(priv.permission.replace(/_/g, ' ')),
        }));
      });
  }


  toggleSelection(item: any, selected: boolean, event: Event) {
    event.stopPropagation();

    setTimeout(() => {
      const control = this.form.get('privileges');
      let selectedValues = [...(control?.value || [])];

      if (selected) {

        selectedValues = selectedValues.filter((id: any) => id !== item.privilegeId);
      } else {

        selectedValues.push(item.privilegeId);
      }

      control?.setValue(selectedValues);
      control?.updateValueAndValidity();
    });
  }

  isSelected(item: any): boolean {
    const selectedValues = this.form.get('privileges')?.value || [];
    return selectedValues.includes(item.privilegeId);
  }


  toTitleCase(str: string): string {
    return str
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  selectAll(ngSelect: NgSelectComponent, controlName: string) {
    const control = this.form.get(controlName);
    if (control) {
      control.setValue(this.privileges.map(p => p.privilegeId));
      control.markAsDirty();
      ngSelect.close();
    }
  }

  closeModal(): void {
    this.form.reset();
    this.dialogRef.close();
  }


  proceed(): void {
    this.isSubmitAttempted = true;

    if (this.form.valid) {
      const formValues = this.form.value;

      this.isSubmitting = true;

      const url = '/assessment/validate'

      this.apiService
        .post(url, formValues)
        .pipe(finalize(() => (this.isSubmitting = false)))
        .subscribe(
          (res: any) => {


            if (!res.success) {
              this.openErrorModal(res.message);
              return;
            }

            else {
              this.dialogRef.close({...res.data, assessmentYear: formValues?.assessmentYear})
            }




          },
          (error) => {
            this.openErrorModal(error?.message)
          }
        );
    }
  }


}
